import Settings from "../domain/Settings";

export function getPageViewId(): string | null {
	if (Settings.getInstance().features.pageViewId && window.openDataLayer?.pageViewId) {
		return window.openDataLayer.pageViewId as string;
	}

	return null;
}
